import { _ } from '@ngx-translate/core';
import { BadgeColors } from '@src/app/components';

export const BADGES = {
  accepted: {
    value: _('components.listItemEvents.constants.badges.accepted'),
    color: BadgeColors.Green,
  },
  cancelled: {
    value: _('components.listItemEvents.constants.badges.cancelled'),
    color: BadgeColors.Red,
  },
  rejected: {
    value: _('components.listItemEvents.constants.badges.rejected'),
    color: BadgeColors.Grey,
  },
};
